/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData, putData } from "utils/Gateway";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { productDetailsHeaderLinks } from "helper/ProductHelper/ProductHelper";
import ProductOfferHeader from "./Header/ProductOffersHeader";
import SaveOffersPopup from "./Popup/SaveOffersPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import OfferFilterPopup from "./Popup/OfferFilterPopup";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { mergeListById } from "helper/Common/CommonHelper";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

const ProductOffersBody = () => {
  const { t, i18n } = useTranslation();

  const params = useParams();

  const token = localStorage.getItem("token");

  const commonHeaderObject = productDetailsHeaderLinks(params.id, t);

  const [name, setname] = useState("");

  // showSkeleton = true  → show skeleton (initial load + filter apply/reset)
  // showSkeleton = false → show table (search typing, pagination, etc.)
  const [showSkeleton, setShowSkeleton] = useState(false);

  const [offers, setOffers] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedOfferIds, setSelectedOfferIds] = useState([]);
  const [selectedOfferId, setSelectedOfferId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // null = filter popup hasn't decided yet (skip API call)
  // []   = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // Global search states — MRT search is manual (server-side)
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get product details
  const getProductDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCT_DETAILS +
        `/${params.id}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const data = response.data;

        setname(data.name);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get all offers
  const getAllProductPricings = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCT_PRICINGS +
        `?productid=${params.id}`;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("requestUrl in getAllProductPricings------>", requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        setMessageType("success");
        setOffers(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
    }
  };

  const getFilteredProductPricings = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_PRODUCT_PRICINGS +
        ``;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log(
        "requestUrl in getFilteredProductPricings------>",
        requestUrl,
      );

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        productid: params.id,
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      if (response.status) {
        setMessageType("success");
        setOffers(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
    }
  };

  const deleteMassiveHandler = async () => {
    if (selectedOfferIds.length > 0) {
      try {
        const offerListToBeDelete = offers.filter((item) =>
          selectedOfferIds.includes(item._id),
        );

        let offerData = {
          productpricinglist: offerListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_PRODUCT_PRICING +
          ``;

        const response = await putData(requestURL, offerData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setOffers((prevList) =>
              prevList.filter((item) => !selectedOfferIds.includes(item._id)),
            );
            setSelectedOfferIds([]);
            setRowSelection({});
          }, 500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one offer for delete");
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const afterPopupCLose = (data = []) => {
    setTimeout(() => {
      setOffers((prev) => mergeListById(prev, data));
    }, 1000);
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSaveOffer"
          aria-controls="offcanvasSaveOffer"
          onClick={() => {
            setSelectedOfferId(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "variant", // use accessorKey instead of field
      header: t("Offer Name"),
    },
    {
      accessorKey: "price",
      header: t("price"),
    },
    {
      accessorKey: "discountprice",
      header: t("Discount"),
    },
    {
      accessorKey: "pricingstartdate",
      header: t("Valid From"),
    },
    {
      accessorKey: "pricingenddate",
      header: t("Valid To"),
    },
    {
      accessorKey: "activestatus",
      header: t("Status"),
    },
  ];

  /* Material React Table Column and States */
  const columns = useMemo(() => initialTableColumns, [i18n.language]);

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  //function for reset filter
  const resetFilterData = () => {
    setGlobalSearch("");
    setRowSelection({});
    setSelectedOfferIds([]);
    setJsonFilterQuery(null);

    setReloadData(true);

    // reset pagination to default
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  useEffect(() => {
    if (params.id) {
      getProductDetails();
    }
  }, [params.id]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedOfferIds(selectedIdsArray);
    } else {
      setSelectedOfferIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (jsonFilterQuery === null) return;

    if (jsonFilterQuery.length > 0) {
      getFilteredProductPricings(debouncedSearch, true);
    } else {
      getAllProductPricings(debouncedSearch, true);
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Search effect — fires when debounced search changes.
  // Skeleton OFF — table stays visible while searching.
  useEffect(() => {
    if (!isDataReady) return;

    if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getFilteredProductPricings(debouncedSearch, false);
    } else {
      getAllProductPricings(debouncedSearch, false);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (reloadData) {
      getAllProductPricings("", true);
      setIsFilterReset(true);
      setReloadData(false);
    }
  }, [reloadData]);

  // ✅ Debounce — after typing 600ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const downloadAsExcel = () => {
    if (offers.length > 0) {
      // Define headers
      const headers = [
        t("Offer Name"),
        t("price"),
        t("Discount"),
        t("Valid From"),
        t("Valid To"),
        t("Status"),
      ];

      // Filter data based on selection
      const filteredList =
        selectedOfferIds.length > 0
          ? offers.filter((item) => selectedOfferIds.includes(item._id))
          : offers;

      // Map data to rows
      const data = filteredList.map((item) => [
        item.variant || "",
        item.price || "",
        item.discountprice || "",
        item.pricingstartdate || "",
        item.pricingenddate || "",
        item.activestatus || "",
      ]);

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Offers"));

      // Write to buffer and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Offers")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  return (
    <div id="content_wrapper">
      <section className="marketplace-wrapper bg-white">
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Offers")}
          />
        )}

        <div className="container-fluid px-lg-5">
          <ProductOfferHeader
            name={name}
            reloadList={refreshRecords}
            jsonFilterQuery={jsonFilterQuery ?? []}
            selectedOfferIds={selectedOfferIds}
            downloadAsExcel={downloadAsExcel}
          />

          {/* table */}
          {showSkeleton || !isDataReady ? (
            <LoadingSkeleton />
          ) : (
            <div className="table-wrapper">
              <MaterialReactTable
                columns={columns} // map columns to be displayed with api data,
                data={offers} // data from api to be displayed
                enableGrouping
                enableRowSelection // enable showing checkbox
                getRowId={(row) => row._id} // map which value to select with row checkbox
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{
                  globalFilter: globalSearch || undefined,
                  rowSelection,
                  pagination: lastPagination,
                  columnVisibility: visibleColoumns,
                  columnOrder: columnOrder,
                }} //pass our managed row selection state to the table to use
                onPaginationChange={setPagination} // set pagination
                autoResetPageIndex={false}
                initialState={{
                  rowSelection,
                  pagination: lastPagination,
                  columnVisibility: visibleColoumns,
                  columnOrder: columnOrder,
                }}
                enableColumnOrdering={true}
                enableRowActions // show the action column
                defaultColumn={{
                  minSize: 20,
                  maxSize: 300,
                  size: 50, //make columns wider by default
                }}
                onColumnVisibilityChange={onColumnVisiblityHandler}
                onColumnOrderChange={changeColumnOrderHandler}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                enableStickyHeader
                // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
              />
            </div>
          )}
        </div>
      </section>

      <SaveOffersPopup
        afterPopupCLose={afterPopupCLose}
        setPricingId={setSelectedOfferId}
        pricingId={selectedOfferId}
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
      />

      <OfferFilterPopup
        moduleSlug="productoffers"
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={refreshRecords}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        setColumnOrder={setColumnOrder}
        setVisibleColoumns={setVisibleColoumns}
        columnOrder={columnOrder}
        visibleColoumns={visibleColoumns}
        columns={columns}
      />

      <DeleteWarningModal
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedOfferIds([]);
        }}
        onDelete={deleteMassiveHandler}
        moduleName={t("Offers")}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default ProductOffersBody;
